import { useTranslation } from "react-i18next";
import { getEventInstancesPath } from "@/entities/data-model";
import { Grid } from "@/shared/components/Grid";
import type { BindableEventFieldset } from "../rowPrimaryIdentity";
import { AddNewEventButton } from "./AddNewEventButton";
import styles from "./AddNewEventFieldPanel.module.scss";

interface AddNewEventFieldPanelProps {
    fieldsets: BindableEventFieldset[];
    onItemAdded: (fieldset: BindableEventFieldset) => void;
}

export const AddNewEventFieldPanel = ({ fieldsets, onItemAdded }: AddNewEventFieldPanelProps) => {
    const { t } = useTranslation();

    if (!fieldsets.length) return null;
    return (
        <Grid.Container>
            <Grid.Field spanMobile={12} spanTablet={12} spanDesktop={12}>
                <ul aria-label={t("event.addEvent")} className={styles.container}>
                    <li aria-hidden="true" className={styles.label}>
                        {t("event.addEvent")}
                    </li>
                    {fieldsets.map((fs) => (
                        <li key={getEventInstancesPath(fs.primaryIdentity)}>
                            <AddNewEventButton fieldset={fs} onItemAdded={onItemAdded} />
                        </li>
                    ))}
                </ul>
            </Grid.Field>
        </Grid.Container>
    );
};
